<script setup lang="ts">
/**
 * リプライ情報 > ベストアンサーアイコン。
 */

import { defineProps } from "vue";

interface Props {
	/**
	 * 「ベストアンサー見出し」文言
	 */
	bestAnswerTitle: string;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-undef
const props = defineProps<Props>();
</script>

<template>
	<div class="revico-community-talk-reply-details-best-answer-icon">{{ bestAnswerTitle }}</div>
</template>

<style lang="scss">
.revico-widget .revico-community-talk {
	&-reply-details-best-answer-icon {
		position: absolute;
		top: 0;
		left: 0;
		padding: 4px 12px 4px 8px;
		color: #fff;
		font-size: 0.8em;
		font-weight: bold;
		border-radius: 0 30px 30px 0;
		background-color: var(--accent-color);
	}
}
</style>
